/* eslint-disable no-shadow */

import React, { Dispatch, memo } from "react";

import { Language } from "../../../../../../services";

import InternalFilters from "./components/Filters";
import Root from "./components/Root";

const Header = memo<Header.Props>(
	({
		filters,

		allowedTaxiServiceIds,
		language,
		isShowMagnifyingGlass,
		onChangeFilters,
	}) => (
		<Root gaps="10px*" align="center" maxedWidth>
			<InternalFilters
				value={filters}
				allowedTaxiServiceIds={allowedTaxiServiceIds}
				language={language}
				isShowMagnifyingGlass={isShowMagnifyingGlass}
				onChange={onChangeFilters}
			/>
		</Root>
	),
);

declare namespace Header {
	interface Props {
		filters: InternalFilters.Value;

		allowedTaxiServiceIds: number[];
		language: Language;
		isShowMagnifyingGlass: boolean;

		onChangeFilters: Dispatch<InternalFilters.Value>;
	}

	namespace Filters {
		type Value = InternalFilters.Value;
		type Props = InternalFilters.Props;
	}
}

export default Header;
